import styled from "styled-components";
import { colors } from "../../../../theme/theme";

export const Container = styled.div`

    button { 
        border-radius: 5px;
    }
`;

export const PageTitle = styled.div`
    border-bottom: 1px solid ${colors.greyscale.light_grey};    
`;

export const PageSubTitle = styled.div` 
    h2 { 
        font-size: 22px;
        color: ${colors.greyscale.dark_grey};
    }
    margin-bottom: 16px;
`;

export const Card = styled.div`
max-width: 940px;
border: 1px solid ${colors.greyscale.light_grey};`;

export const CardHeader = styled.div` 
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${colors.greyscale.light_grey};
    padding: 20px;
`;

export const CardBody = styled.main` 
    padding: 20px;
    padding-top: 20px;
    padding-bottom: 40px;    

    label { 
        color: ${colors.greyscale.darker_grey};

        margin-top: 5px;
    }
`;

export const CardFooter = styled.div`
    display: flex;
    justify-content: space-between;
    border-top: 1px solid ${colors.greyscale.light_grey};
    padding: 20px;

`;


export const ConcludeBtn = styled.button`
    border: 1px solid ${colors.mainColors.light_verde_dstore};
    background-color: ${colors.mainColors.light_verde_dstore};
    padding: 8px;
    color: #fff;

    &:hover { 
        transition: 0.2s ease-in-out;
        background-color: ${colors.mainColors.dark_verde_dstore};
        border: 1px solid ${colors.mainColors.dark_verde_dstore};
    }
`;

export const TokenBtn = styled.button`
    border: 1px solid ${colors.mainColors.blueberry};
    background-color: transparent;
    color: ${colors.mainColors.blueberry};
    padding: 8px;

    &:hover { 
        transition: 0.2s ease-in-out;
        color: ${colors.mainColors.hover_blueberry};
        border: 1px solid ${colors.mainColors.hover_blueberry};
    }
`;